// <head> metadata for WebcastDbosConductorIntroPage (https://www.dbos.dev/webcast-dbos-conductor-intro).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Webcast: Introducing DBOS Conductor',
    },
    {
      name: 'description',
      content:
        'In this webinar, DBOS co-founders, Qian Li and Peter Kraft will show you to deploy, scale, and manage DBOS Transact applications on any platform.',
    },
    {
      property: 'og:title',
      content: 'Webcast: Introducing DBOS Conductor',
    },
    {
      property: 'og:description',
      content:
        'In this webinar, DBOS co-founders, Qian Li and Peter Kraft will show you to deploy, scale, and manage DBOS Transact applications on any platform.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/67f21e8d6455127fccef0a9c_Durable-Execution-Anywhere-Webcast.png',
    },
    {
      name: 'twitter:title',
      content: 'Webcast: Introducing DBOS Conductor',
    },
    {
      name: 'twitter:description',
      content:
        'In this webinar, DBOS co-founders, Qian Li and Peter Kraft will show you to deploy, scale, and manage DBOS Transact applications on any platform.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/67f21e8d6455127fccef0a9c_Durable-Execution-Anywhere-Webcast.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/webcast-dbos-conductor-intro',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
